<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">LIST OF LOANS PENDING</h4></v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap class="align-center mx-2 mt-4">
        <v-flex xs12 md4>
          <v-select
            class="mx-2"
            v-model="status"
            :items="['Unpaid','Paid']"
            label="Status"
            required
            :rules="rules.combobox_rule"
            dense
            outlined
            @change="search_data"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-data-table dense
                    class="mt-3"
                    :headers="headers"
                    :items="data"
                    disable-pagination
                    hide-default-footer
                    :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>

            <v-text-field
              class="mx-2"
              :append-icon="icons.mdiAccountSearchOutline"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>
              {{
                data
                  .map(function (x) {
                    return x.id
                  })
                  .indexOf(item.id) + 1
              }}
            </td>
            <td>
              {{ item.date }}
            </td>
            <td>
              {{ item.member.company_name }}
            </td>
            <td>
              {{ item.collateral }}
            </td>
            <td>
              {{ formatPrice(item.loan_amount) }}
            </td>
            <td>
              {{ item.terms + ' months' }}
            </td>
            <td>
              {{ item.interest + ' %' }}
            </td>
            <td>
              {{ formatPrice(item.total_interest) }}
            </td>
            <td>
              {{ formatPrice(item.total_loan) }}
            </td>
            <td>
              {{ formatPrice(get_balance(item)) }}
            </td>
            <td class="text-center">
              <v-icon
                class="mr-2"
                color="error"
                @click="status_loan(item,2)"
              >
                {{ icons.mdiThumbDown }}
              </v-icon>
              <v-icon
                class="mr-2"
                color="success"
                @click="status_loan(item,1)"
              >
                {{ icons.mdiThumbUp }}
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <snack-bar-dialog :snackbar_flag="this.snackbar" :color="this.snackbar_color"
                      :snackbar_text="this.snackbar_text"/>
  </div>
</template>

<script>
import {
  mdiCheck, mdiClose, mdiPlusBox
  , mdiPencil
  , mdiAccountSearchOutline
  , mdiAccountClock
  , mdiThumbDown
  , mdiThumbUp
} from '@mdi/js'
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'
import {P} from 'caniuse-lite/data/agents'

const initialState = () => {
  return {
    search: '',
    status: '',
    type_of_loan: '',
    data: [],
    headers: [
      {text: 'No.', value: 'id', sortable: false},
      {text: 'Date', value: 'date', sortable: false},
      {text: 'Name', value: 'name', sortable: false},
      {text: 'Collateral', value: 'date', sortable: false},
      {text: 'Loan Amount', value: 'loan_amount', sortable: false},
      {text: 'Terms', value: 'terms', sortable: false},
      {text: 'Interest (%)', value: 'interest', sortable: false},
      {text: 'Interest', value: 'total_interest', sortable: false},
      {text: 'Total Loan', value: 'total_loan', sortable: false},
      {text: 'Loan Balance', value: 'total_loan', sortable: false},
      {text: 'Action', value: 'total_loan', sortable: false},
    ],
  }
}
export default {
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiCheck,
        mdiClose,
        mdiPlusBox,
        mdiPencil,
        mdiAccountSearchOutline,
        mdiAccountClock,
        mdiThumbDown,
        mdiThumbUp,
      },
    }
  },
  data() {
    return initialState()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
    ...mapGetters('authentication', ['position', 'company_name', 'branch_id', 'branch_contact_no', 'branch_address', 'branch', 'branch_id_selected']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('loan', ['list_of_loans_pending', 'update_status_loan']),
    search_data() {
      this.list_of_loans_pending()
        .then(response => {
          this.data = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    date_format(value) {
      return moment(value)
    },
    get_balance(value) {
      var paid = 0;
      value.payment_paid.forEach(function (item) {
        paid += (parseFloat(item.amount) + parseFloat(item.interest))
      })
      return parseFloat(value.total_loan) - parseFloat(paid)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    status_loan(data, status) {
      this.update_status_loan({
        id: data.id,
        status: status,
      })
        .then(response => {
          var color = 'success'
          if (response.status === 201) {
            color = 'error'
          }
          this.change_snackbar({
            show: true,
            color: color,
            text: response.data,
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
